module.exports = __webpack_public_path__ + "img/related-image-01.1c017da9.jpg";